import { createAsyncThunk } from "@reduxjs/toolkit"
import { getRequest, getRequestPerEnv } from "./utils/GetRequest"
import { useSelector } from "react-redux";
import { RootState } from "../root-redux/RootState";


export const getUserGroups = createAsyncThunk<string[], string,{ state: RootState }>('workflows/groups/getUserGroups' , async (userEmailId:string,{ getState }) => {
  const env = getState().env.selectedEnvItem;
    var domain = env === 'dev' || env === 'uat' ? 'predictions' : 'audit';
    const response = await getRequestPerEnv<string[]>(`${domain}/groups/${userEmailId}`, env);
    return response.data
  })

